const appendFilterParams = (searchParams, prefix, value) => {
  if (value === null || value === undefined || value === "") {
    return
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      appendFilterParams(searchParams, `${prefix}[${index}]`, item)
    })
    return
  }

  if (typeof value === "object") {
    Object.entries(value).forEach(([key, nestedValue]) => {
      appendFilterParams(searchParams, `${prefix}[${key}]`, nestedValue)
    })
    return
  }

  searchParams.append(prefix, value)
}

const normalizeFilterValue = (value) => {
  if (value === null || value === undefined || value === "") return undefined
  if (Array.isArray(value)) {
    const normalized = value
      .map(item => (typeof item === "object" ? item.value : item))
      .filter(item => item !== null && item !== "" && item !== "all")
    return normalized.length > 0 ? normalized : undefined
  }
  if (typeof value === "object" && value.value !== undefined) {
    return value.value !== "all" ? value.value : undefined
  }
  return value
}

export const buildFilterParams = filters => {
  const params = { filters: {} }

  Object.entries(filters || {}).forEach(([key, value]) => {
    const normalized = normalizeFilterValue(value)
    if (normalized !== undefined) {
      params.filters[key] = normalized
    }
  })

  return params
}

export const buildFlatFilterParams = filters => {
  const params = {}

  Object.entries(filters || {}).forEach(([key, value]) => {
    const normalized = normalizeFilterValue(value)
    if (normalized !== undefined) {
      params[key] = normalized
    }
  })

  return params
}

export const serializeFilterParams = (filters, extraParams = {}) => {
  const searchParams = new URLSearchParams()

  Object.entries(extraParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      searchParams.append(key, value)
    }
  })

  const normalized = buildFilterParams(filters)
  Object.entries(normalized.filters || {}).forEach(([key, value]) => {
    appendFilterParams(searchParams, `filters[${key}]`, value)
  })

  return searchParams.toString()
}

export const hasActiveDashboardFilters = (filters = {}) =>
  Object.values(filters).some(value => {
    if (value === null || value === undefined || value === "") {
      return false
    }
    if (Array.isArray(value)) {
      return value.length > 0
    }
    return true
  })

export const parseFilterSearchParams = searchParams => {
  const filters = {}

  searchParams.forEach((value, key) => {
    if (key === "type") {
      return
    }

    const nestedFilterMatch = key.match(/^filters\[(.+?)\](?:\[(\d+)\])?$/)
    if (nestedFilterMatch) {
      const [, filterKey, index] = nestedFilterMatch
      if (index !== undefined) {
        if (!filters[filterKey]) {
          filters[filterKey] = []
        }
        filters[filterKey][Number(index)] = value
      } else {
        filters[filterKey] = value
      }
      return
    }

    const arrayMatch = key.match(/^(.+)\[(\d+)\]$/)
    if (arrayMatch) {
      const [, base, index] = arrayMatch
      if (!filters[base]) {
        filters[base] = []
      }
      filters[base][Number(index)] = value
      return
    }

    filters[key] = value
  })

  return filters
}

export const expandMultiSelectValue = (selected, options = []) => {
  if (!selected) {
    return null
  }

  const hasAll = selected.some(item => item.value === "all")
  if (hasAll) {
    return null
  }

  return selected
}
